var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-content',{staticClass:"prime-compliance-page"},[_c('div',{staticClass:"prime-compliance-page-container"},[_c('img',{staticClass:"mypcp-logo",attrs:{"src":require("../assets/logo.svg")}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pageCopy.privacyPolicy.content)}}),_c('footerCompliance')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }